import React, { useEffect } from 'react'

import Logo from '../HeaderSharedComponents/Logo'
import MenuMobile from '../HeaderSharedComponents/Menu/MenuMobile'
import { useHeaderContext } from '../Hooks/headerStates'

import * as S from './styled'

const HeaderMobile  = ( {brand} ) => {

  const menuMobileCheck = useHeaderContext()
  const menuOpenState = menuMobileCheck.getMenuMobileOpenState()

  const scrollToTopMenu = () => {
    const menu = document.getElementById('menuMobile')
    const isFirefox = typeof InstallTrigger !== 'undefined'
    menu.scrollTo({ top: 0, left: 0, behavior: isFirefox ? 'auto' : 'smooth' })
  }

  const openMenuMobile = () => {
    menuMobileCheck.setMenuMobileOpenState(isOpen => !isOpen)
    menuMobileCheck.setSubmenuMobileVisibleState(false)
    scrollToTopMenu()
  }

  const executiveBody = document.getElementsByTagName('BODY')[0]
  useEffect(() => {
    if (menuOpenState) {
      executiveBody.classList.add('block-scroll')
    } else {
      executiveBody.classList.remove('block-scroll')
    }
  }, [menuOpenState])

  return (
    <>
      <S.Main data-testid="main-main">
        {menuOpenState ?
        <S.LogoMenuBurger />
        :
        <>
        <Logo brand={brand} />
          <S.MenuText data-testid="menuText-p">
            Menu
          </S.MenuText>
        </>
        }
        <S.MenuButton onClick={openMenuMobile} data-testid="menuButton-button">
          {menuOpenState ? <S.MenuCloseIcon size="30" /> : <S.MenuIcon size="30" />}
        </S.MenuButton>
      </S.Main>
      <MenuMobile />
    </>
  )
}

export default HeaderMobile
